var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYelloCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 66,
    viewBox: "0 0 255 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.6363 13.4878C49.3407 14.9105 39.3062 17.0423 29.4254 19.6723C20.2962 22.1023 5.26802 27.4071 3.30687 33.1459C1.3457 38.8846 6.77995 46.7129 22.5175 52.4566C38.2552 58.2002 68.7632 63.2187 94.4635 64.6189C120.164 66.0189 153.282 65.9715 174.588 64.6189C174.588 64.6189 246.269 61.5637 251.689 37.8026C257.11 14.0413 167.029 5.13087 116.344 3.66283C65.6579 2.1948 44.4583 6.06605 11.3153 11.2953",
    stroke: "#FFD970",
    strokeWidth: 5.54051,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYelloCircle);
export default __webpack_public_path__ + "static/media/yello-circle.9c3c849e1dcaf0f96af8c94ac5810c02.svg";
export { ForwardRef as ReactComponent };